// extracted by mini-css-extract-plugin
export var brand = "_23-9";
export var compact = "_23-6";
export var extraSmall = "_23-7";
export var icon = "_23-0";
export var large = "_23-4";
export var light = "_23-1";
export var medium = "_23-5";
export var outline = "_23-b";
export var primaryDark = "_23-a";
export var primaryLight = "_23-8";
export var primaryModern = "_23-c";
export var success = "_23-2";
export var successSolid = "_23-3";